<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pNTPvc/tc-custom/9781788853040.jpg?1700797561740" alt="This image is the cover for the book In Search of Angels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In Search of Angels
      </h1>
      <p class="bookDescription body article font2">
        <b>“This account of four west coast journeys in search of the remnants of the earliest Christian missionaries is intriguing . . . Moffat is an engaging guide.” —<i>The Scotsman</i></b><br/><br/>Fourteen centuries ago, Irish saints brought the Word of God to the Hebrides and Scotland’s Atlantic shore. These “white martyrs” sought solitude, remoteness, even harshness, in places apart from the world where they could fast, pray and move closer to an understanding of God: places where they could see angels. Columba, who founded the famous monastery at Iona, was the most well-known of these courageous men who rowed their curraghs towards danger and uncertainty in a pagan land, but the many others are now largely forgotten by history. <br/><br/>In this book, Alistair Moffat journeys from the island of Eileach an Naoimh at the mouth of the Firth of Lorne to Lismore, Iona and then north to Applecross, searching for traces of these extraordinary men. He finds them not often in any tangible remains, but in the spirit of the islands and remote places where they passed their exemplary lives. Brendan, Moluag, Columba, Maelrubha and others brought the Gaelic language and echoes of how the saints saw their world can still be heard in its cadences. And the tradition of great piety endures.<br/><br/><b>“This account of four journeys to three small islands and a remote peninsula in the Scottish north-west has an air of exotic adventure.” —<i>The Times Literary Supplement</i></b><br/><br/><b>“I was drawn to Moffat’s personal response to pilgrimage as he retraced the spiritual journeys of the early monks . . . This delightful book is part history, part pilgrimage.” —<i>Church Times</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alistair Moffat
      </h2>
      
      <p class="authorDescription body article">Alistair Moffat was born and bred in the Scottish Borders. A former Director of the Edinburgh Festival Fringe and Director of Programmes at Scottish Television, he now runs the burgeoning Borders Book Festival as well as a production company based near Selkirk. He has written twelve books, including Kelsae, The Reivers, The Sea Kingdoms, The Borders and The Wall, all of which are published by Birlinn.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19db8217